import styled from 'styled-components';

export const Svg = styled.svg`
  width: 54px;
  height: 54px;
`;

export const Path = styled.path`
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;

  @keyframes progress {
    0% {
      stroke-dasharray: 0 100;
    }
  }
`;
